<div class="x-card x-card_size_m x-white card-shadow">
  <form [formGroup]="form" class="flex flex-col gap-4">
    <tui-textfield tuiTextfieldSize="m">
      <label tuiLabel>
        {{ 'group_actions.release_date.date' | translate }}
      </label>

      <input tuiInputDate formControlName="releaseDate" />
      <tui-calendar *tuiDropdown />
    </tui-textfield>

    <label class="x-font-body-3 text-(--tui-text-primary)">
      {{ 'group_actions.release_date.time' | translate }}
    </label>
    <div class="grid grid-cols-2 gap-3">
      <tui-textfield tuiChevron tuiTextfieldSize="m">
        <label tuiLabel>
          {{ 'group_actions.release_date.hour' | translate }}
        </label>

        <input tuiSelect formControlName="hour" />
        <tui-data-list *tuiDropdown>
          @for (hour of hours; track hour) {
            <button tuiOption type="button" [value]="hour">{{ hour }}</button>
          }
        </tui-data-list>
      </tui-textfield>

      <tui-textfield tuiChevron tuiTextfieldSize="m">
        <label tuiLabel>
          {{ 'group_actions.release_date.minute' | translate }}
        </label>

        <input tuiSelect formControlName="minute" />
        <tui-data-list *tuiDropdown>
          @for (minute of minutes; track minute) {
            <button tuiOption type="button" [value]="minute">
              {{ minute }}
            </button>
          }
        </tui-data-list>
      </tui-textfield>
    </div>

    @if (isTimeSelectionIncomplete) {
      <p class="x-font-caption-1 text-(--x-color-danger)">
        {{ 'group_actions.release_date.incomplete_time' | translate }}
      </p>
    }

    @if (isTransferReasonMissing) {
      <p class="x-font-caption-1 text-(--x-color-danger)">
        {{ 'group_actions.release_date.transfer_reason_required' | translate }}
      </p>
    }

    <ng-container [formGroup]="form.controls.transferReason">
      <tui-textfield
        tuiChevron
        tuiTextfieldSize="m"
        [stringify]="stringifyReason"
      >
        <label tuiLabel>
          {{ 'group_actions.release_date.transfer_reason' | translate }}
        </label>

        <input tuiSelect formControlName="reasonId" />
        <tui-data-list *tuiDropdown>
          @for (reason of $reasons(); track reason.id) {
            <button tuiOption type="button" [value]="reason.id">
              {{ reason.name }}
            </button>
          }
        </tui-data-list>
      </tui-textfield>
    </ng-container>

    <button
      tuiButton
      appearance="primary"
      type="button"
      [disabled]="
        !hasAnyValue || isTimeSelectionIncomplete || isTransferReasonMissing
      "
      (click)="apply()"
    >
      {{ 'group_actions.release_date.apply' | translate }}
    </button>
  </form>
</div>
